module.exports = __webpack_public_path__ + "img/logo-dark.22404b1e.svg";